import PhoneNr from '../../form/PhoneNr.react';
import UserStore from '../../../stores/UserStore';

class PosProfile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showId : false
        };
    }

    render() {
    	var guest = this.props.guest;
        var userData = UserStore.getState();
        var selectedLocation = userData.selectedLocation;

    	if (!guest)
            return null;

        var mjStateId = false;
        var driverLicense = false;

        for (var i=0; i<guest.identifications.length; i++) {
            if (guest.identifications[i].type === 'MJStateIDNo')
                mjStateId = guest.identifications[i];
            else if (guest.identifications[i].type === 'DriversLicenseId')
                driverLicense = guest.identifications[i];
        }

        var expirationClass = '';
        var currentDate = moment(mjStateId.ExpirationDate);
        if (mjStateId && mjStateId.ExpirationDate.length > 0) {
            var futureMonth = moment(moment(new Date().getTime()));

            if (currentDate.diff(futureMonth, 'days') < 45)
                expirationClass = 'sidebar-table__error';
        }
        
        var driverLicenseExpired = !!driverLicense && moment(driverLicense.ExpirationDate) < moment();
        var showTransactionReference = (guest.TransactionReference !== (guest.ShipmentId || '').toString())

        return (
            <div className='pos-sidebar__content'>
            	<div className='pos-profile__name'>
            		{guest.FullName}
            	</div>

                { selectedLocation.IndicateLoyaltyMember && guest.IsLoyaltyMember &&
                    <div className='pos-profile__name'>
                        <b>LOYALTY MEMBER</b> <img width='20' height='20' src='/assets/star.png' />
                    </div>
                }

                { mjStateId && mjStateId.image_url.length > 0 &&
                    <img
                        src={'data:image/png;base64, '+mjStateId.image_url}
                        className='pos-sidebar__content--id'
                        onClick={() => { this.setState({ showId : true}, () => { $('.pos-sidebar').css({ 'z-index' : 999 }) }) }} />
                }

                <table className='sidebar-table'>
                    <tbody>
                        {
                        showTransactionReference &&
                        <tr>
                            <td>Reference #</td>
                            <td>{guest.TransactionReference}</td>
                        </tr>
                        }

                        <tr>
                            <td>Date of Birth</td>
                            <td>{guest.DOB.length > 0 ? moment(guest.DOB).format('DD MMM YYYY') : 'N/A'}</td>
                        </tr>
                        <tr>
                            <td>MMJ ID</td>
                            <td
                                className='txt-spacing-m'
                                style={{'position':'relative','whiteSpace':'noWrap'}}>

                                <div className='sidebar-table__mjstateid'>{guest.MJStateIDNo}</div>
                            </td>
                        </tr>
                        { userData.selectedLocation.MJIDStartDateField &&
                        <tr>
                            <td>MMJ ID Start Date</td>
                            <td>{mjStateId.StartDate.length > 0 ? moment(mjStateId.StartDate).format('DD MMM YYYY') : 'N/A'}</td>
                        </tr>
                        }
                        <tr
                            className={expirationClass}>

                            <td>MMJ ID Exp</td>
                            <td>{mjStateId.ExpirationDate.length > 0 ? moment(mjStateId.ExpirationDate).format('DD MMM YYYY') : 'N/A'}</td>
                        </tr>
                        <tr>

                            <td style={{ color: driverLicenseExpired ? 'red' : null}}>DL Exp Date</td>
                            <td style={{ color: driverLicenseExpired ? 'red' : null}}>
                                {driverLicense.ExpirationDate.length > 0 ? moment(driverLicense.ExpirationDate).format('DD MMM YYYY') : 'N/A'}
                            </td>
                        </tr>
                        <tr>
                            <td>Transaction Id</td>
                            <td className='txt-spacing-m'>{guest.ShipmentId}</td>
                        </tr>
                        <tr
                            className='sidebar-table__border'>

                            <td>Cycle Date</td>
                            <td>{guest.CycleDate.length > 0 ? moment(guest.CycleDate).format('DD MMM YYYY') : 'N/A'}</td>
                        </tr>
                        <tr>
                            <td>Address</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colSpan='2'>{guest.address.street}</td>
                        </tr>
                        <tr className='sidebar-table__border'>
                            <td colSpan='2'>{guest.address.postal_code}, {guest.address.city}, {guest.address.state}</td>
                        </tr>
                        <tr className='sidebar-table__border'>
                            <td>Phone</td>
                            <td><PhoneNr nr={guest.PhoneNo} /></td>
                        </tr>

                        { guest.discounts.length > 0 &&
                            <tr>
                                <td>Group 1</td>
                                <td>{guest.discounts[0].title}</td>
                            </tr>
                        }

                        { guest.discounts.length > 1 &&
                            <tr>
                                <td>Group 2</td>
                                <td>{guest.discounts[1].title}</td>
                            </tr>
                        }

                        { guest.discounts.length > 2 &&
                            <tr>
                                <td>Group 3</td>
                                <td>{guest.discounts[2].title}</td>
                            </tr>
                        }

                        <tr className='sidebar-table__border-top'>
                            <td>Primary Caregiver</td>
                            <td>{guest.CGFirstName} {guest.CGLastName}</td>
                        </tr>
                        <tr className='sidebar-table__border'>
                            <td>Caregiver ID</td>
                            <td>{guest.CaregiverMJStateIdNo}</td>
                        </tr>

                        <tr>
                            <td>Additional Caregiver</td>
                            <td>{guest.CaregiverName2}</td>
                        </tr>
                        <tr className='sidebar-table__border'>
                            <td>Caregiver DOB</td>
                            <td>{guest.CaregiverDOB2}</td>
                        </tr>
                    </tbody>
                </table>
                { this.state.showId &&
                    <div
                        className='pos-profile__id'
                        onClick={() => { this.setState({ showId : false }, () => { $('.pos-sidebar').css({ 'z-index' : 2 }) }) }}>

                        <img src={'data:image/png;base64, '+mjStateId.image_url} />
                    </div>
                }
	        </div>
        );
    }
}

export default PosProfile;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/PosProfile.react.jsx